// 自定义 Vue 插件，在 main.js 中使用 Vue.use() 进行安装
/* eslint-disable no-param-reassign */
import Language from '@/lib/utils/language';
import TheHeading from '@/components/TheHeading.vue';

export default {
    install(Vue) {
        // 全局的语言插件
        Vue.prototype.$language = new Language();

        // 全局的 TheHeading 组件
        Vue.component(TheHeading.name, TheHeading);

        // 其他全局组件、指令、属性、方法等......
    },
};
